export enum UserType {
  'CLASSIC_NORMAL_USER' = 'CLASSIC_NORMAL_USER',
  'CLASSIC_BIND_WECHAT_USER' = 'CLASSIC_BIND_WECHAT_USER',
  'WECHAT_USER' = 'WECHAT_USER',
  'WECHAT_USER_EXIST_DUPLICATE_ACCOUNT_USER' = 'WECHAT_USER_EXIST_DUPLICATE_ACCOUNT_USER',
}
